import { FuelType, SelfServiceType } from '../models/FuelingService.ts';

export const fuelTypeMap: Record<FuelType, { label: string; order: number }> = {
  RON_92: { label: '92', order: 1 },
  RON_95: { label: '95', order: 2 },
  RON_98: { label: '98', order: 3 },
  DIESEL: { label: '超柴', order: 4 },
  E3_GASOHOL: { label: '酒精', order: 5 },
};

export const selfServiceTypeMap: Record<
  SelfServiceType,
  { label: string; order: number }
> = {
  GAS_SELF_SERVICE: { label: '汽油自助', order: 1 },
  DIESEL_SELF_SERVICE: { label: '柴油自助', order: 2 },
};
